export default "__VITE_ASSET__xt_UZ3Zb__"